<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-btn
					icon
					@click="
						$inertia.visit(
							$route(
								'central.pushnotifications.index',
								$page.props
							)
						)
					"
					><v-icon>mdi-arrow-left</v-icon></v-btn
				>
				{{ $t("title.show_push_notification") }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs10 md8>
						<v-layout row wrap>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{
										$t("label.image_link")
									}}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
								>
									{{ push_notification.image_link }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("Name") }}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
								>
									{{ push_notification.name }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("label.text") }}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
								>
									{{ push_notification.text }}
								</v-list-item-title>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("Title") }}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
								>
									{{ push_notification.title }}
								</v-list-item-title>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["push_notification"],
};
</script>